var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"container"},[_c('section',{attrs:{"id":"opening-text"}},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.headerTitle))])]),_c('h3',[_vm._v(" "+_vm._s(_vm.headingSubTxt)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }